/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "LandingPageService";
const log: any = LoggerModule.getInstance();

export class LandingPageService {
  private static instance: LandingPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): LandingPageService {
    if (!LandingPageService.instance) {
      LandingPageService.instance = new LandingPageService(props);
    }
    return LandingPageService.instance;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //HeroSection Props
    compProps = await agent.getHeroSectionProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //ImageSection Props
    compProps = await agent.getImageFeatureSectionProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Main Props
    compProps = await agent.getMainSectionProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Feature Section Props
    compProps = await agent.getFeatureSectionProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Footer Props
    compProps = await agent.getFooterProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getBrandProfile() {
    let compProps: any = null;
    let content: any = {};
    const agent = getAgent();
    compProps = await agent.getBrandProfile();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getCurrencyExchangeRate() {
    const agent = getAgent();
    return agent.getCurrencyExchangeRate();
  }
}
